import { dcpcApi } from './dcpcApi';

dcpcApi.enhanceEndpoints({});

const userLogsApi = dcpcApi.injectEndpoints({
    endpoints: (builder) => ({

        getUserActions: builder.query({
            query: (args) => `user-actions?${args}`,
        }),

    }),
});

export const {
    useGetUserActionsQuery,
    useLazyGetUserActionsQuery,
} = userLogsApi;
